module.exports = __webpack_public_path__ + "static/img/h9.e4d0352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h9.jpg
// module id = yh99
// module chunks = 0